import { useNavigate } from "react-router-dom";

const SiteSelector = () => {
  const navigate = useNavigate();
  const sites = JSON.parse(localStorage.getItem('customerSites') || '[]');

  const handleSelect = (site) => {
    localStorage.setItem('siteId', site._id);
    localStorage.setItem('siteName', site.site_name);
    localStorage.removeItem('customerSites'); // clean up temp storage
    navigate('/customer/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Select Your Site</h1>
          <p className="text-gray-500 mt-2">Choose which site you are placing an order for</p>
        </div>

        <div className="space-y-3">
          {sites.map((site) => (
            <button
              key={site._id}
              onClick={() => handleSelect(site)}
              className="w-full bg-white border border-gray-200 rounded-xl p-5 text-left hover:border-gray-900 hover:shadow-md transition-all group"
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-900 group-hover:text-gray-700">
                    {site.site_name}
                  </p>
                  {site.address && (
                    <p className="text-sm text-gray-500 mt-1">{site.address}</p>
                  )}
                  {site.site_code && (
                    <span className="inline-block mt-2 text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                      {site.site_code}
                    </span>
                  )}
                </div>
                <svg className="w-5 h-5 text-gray-400 group-hover:text-gray-900 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SiteSelector;